import { render, staticRenderFns } from "./modalInfo.vue?vue&type=template&id=e6adbad0"
import script from "./modalInfo.vue?vue&type=script&lang=js"
export * from "./modalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports